export default __webpack_public_path__ + "static/media/dreamstime_s_20658184.4d31c281.jpg";